export const vsName = "slotTrakMachinesServer";

export class SlotTrakServerAdapter {
  static $inject = [];

  constructor() {}
}
